/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-05-08 14:35:29
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-11-27 14:47:30
 */
import { defineStore } from 'pinia'

import type { DropMenuInfo, UserInfo, UserState } from './helper'
import { defaultSetting, setLocalState } from './helper'
import { store, useWorkspaceStore } from '@/store'
import { getDropUserInfo, getUserInfo, getUserExtra } from '@/api'

interface UseUserState extends UserState {
  balanceCount: number
}

export const useUserStore = defineStore('user-store', {
  // state: (): UserState => getLocalState(),
  state: (): UseUserState => ({
    ...defaultSetting(),
    balanceCount: 0, // 能量点值
  }),
  actions: {
    updateUserInfo(userInfo: Partial<UserInfo>) {
      this.userInfo = { ...this.userInfo, ...userInfo }
    },

    async updateDropMenuInfo() {
      const workspaceStore = useWorkspaceStore()
      const enterpriseId = workspaceStore.workspaceId
      return getDropUserInfo({ enterpriseId }).then((res: DropMenuInfo) => {
        this.dropMenuInfo = res
        // userInfo里面的那个有缓存，在这里更新
        this.updateUserInfo({ balance: res.balance })
      })
    },

    async getUserInfo() {
      return getUserInfo().then((res: UserInfo) => {
        this.updateUserInfo(res)
      })
    },

    // 获取当前工作空间下的可用能量点
    async getBalance() {
      const workspaceStore = useWorkspaceStore()
      const workspaceId = workspaceStore.workspaceId
      const isPersonal = workspaceStore.isPersonal

      await this.updateDropMenuInfo()

      const currentEnterpriseAmount = this.dropMenuInfo.enterpriseAmount.find(item => item.enterpriseId === workspaceId)

      if (isPersonal) {
        this.updateBalanceCount(this.userInfo.balance)
        return this.userInfo.balance
      } else {
        this.updateBalanceCount(currentEnterpriseAmount?.balance || 0)
        return currentEnterpriseAmount?.balance || 0
      }
    },

    updateBalanceCount(val: number) {
      this.balanceCount = val
    },

    getBalanceCount() {
      return this.balanceCount
    },

    async updateUserExtraInfo() {
      await getUserExtra().then(res => {
        this.userExtraInfo = { ...this.userExtraInfo, ...res }
      })
    },

    resetUserInfo() {
      this.userInfo = { ...defaultSetting().userInfo }
    },

    recordState() {
      setLocalState(this.$state)
    },

    resetState() {
      this.$state = defaultSetting()
    },
  },
  getters: {
  },
})

export function useUserStoreWithout() {
  return useUserStore(store)
}
